<template>
  <div class="md:px-8 mt-6 md:mt-8 text-left">
    <div class="md:rounded bg-grey-50 flex justify-center py-6">
      <div class="flex flex-col md:flex-row w-full">
        <div class="px-8 md:px-0 md:flex justify-end md:w-40 mb-4 md:mb-0">
          <div
            class="w-15 h-15 rounded-full border-1 border-grey-100 bg-white flex items-center justify-center overflow-hidden"
          >
            <img
              v-if="contactPerson.photo"
              :src="contactPerson.photo.src"
              :width="contactPerson.photo.width"
              height="contactPerson.photo.height"
              alt=""
            />
            <svg
              v-else
              viewBox="0 0 22 24"
              height="24"
              width="22"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
            >
              <g
                style="
                  fill: none;
                  fill-rule: evenodd;
                  stroke: #e31721;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                  stroke-width: 1.5;
                "
                transform="translate(1)"
              >
                <circle cx="10" cy="6" r="5.25" />
                <path
                  d="m.25 23.25c0-5.3847763 4.36522369-9.75 9.75-9.75 5.3847763 0 9.75 4.3652237 9.75 9.75"
                />
              </g>
            </svg>
          </div>
        </div>

        <div class="flex-auto px-8 flex flex-wrap -m-3">
          <div class="w-full lg:w-auto lg:flex-1 p-3">
            <h2
              class="text-red uppercase font-roboto-condensed text-xs leading-tighter tracking-px font-bold"
            >
              Ihr Ansprechpartner
            </h2>

            <div class="text-base leading-normal font-semibold mt-1">
              {{ contactPerson.name }}
            </div>
            <p class="text-xs leading-normal text-grey-200">
              Fuhrparkmanagement
            </p>
          </div>
          <div
            class="w-full lg:w-auto lg:flex-1 leading-tightest space-y-3 p-3 flex flex-col justify-end"
          >
            <div v-if="contactPerson.phone" class="flex relative items-center">
              <svg
                class="mr-2 text-red"
                width="16"
                height="16"
                aria-hidden="true"
                focusable="false"
              >
                <use xlink:href="#phone-filled" />
              </svg>
              <a
                :href="`tel:${contactPerson.phone}`"
                class="link-inline dealer-entry-phone"
                >{{ contactPerson.phone }}</a
              >
            </div>
            <div v-if="contactPerson.email" class="flex relative items-center">
              <svg
                class="mr-2 text-red"
                width="16"
                height="16"
                aria-hidden="true"
                focusable="false"
              >
                <use xlink:href="#mail-filled" />
              </svg>
              <a
                :href="`mailto:${contactPerson.email}`"
                class="link-inline dealer-entry-ansprechperson_fuhrpark_email"
                target="_blank"
                rel="noopener"
                >{{ contactPerson.email }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactPerson: {
      type: Object,
      required: true,
    },
  },
};
</script>
